import React, { useState } from "react";
import { bool, number } from "prop-types";

import theme from "theme";

export function DeleteIcon({ dimension, includeSurround, ...props }) {
  const [hover, setHasHover] = useState(false);

  return (
    <svg
      width={dimension}
      height={dimension}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setHasHover(true)}
      onMouseLeave={() => setHasHover(false)}
      {...props}
    >
      {includeSurround && (
        <path
          d="M54.1716 27.8912C54.1716 28.62 54.1374 29.3477 54.0715 30.0725L55.0674 30.163C54.847 32.587 54.2863 34.9692 53.4751 37.2471L52.533 36.9116C52.0371 38.3043 51.4437 39.6589 50.7744 40.9599L51.6636 41.4174C50.5244 43.6319 49.1739 45.6896 47.7146 47.5194L46.9328 46.8959C46.4654 47.482 45.9868 48.0437 45.5008 48.5783C45.0628 49.0601 44.6049 49.5078 44.1287 49.9237L44.7865 50.6769C43.122 52.1305 41.246 53.2179 39.2244 54.0176L38.8566 53.0877C37.6639 53.5596 36.4118 53.929 35.1132 54.212L35.3261 55.189C33.2471 55.6421 31.0725 55.8769 28.86 55.962L28.8215 54.9627C28.1593 54.9882 27.4926 55 26.8228 55C26.1478 55 25.4738 54.9904 24.8026 54.969L24.7707 55.9685C22.553 55.8976 20.3538 55.6988 18.2445 55.289L18.4353 54.3073C17.1165 54.0511 15.8434 53.7114 14.632 53.2689L14.2889 54.2082C12.2205 53.4527 10.3029 52.4034 8.61936 50.9631L9.26944 50.2032C8.78766 49.7911 8.32637 49.3448 7.88759 48.8618C7.41324 48.3396 6.9634 47.7875 6.53801 47.2082L5.73199 47.8001C4.35636 45.9268 3.23554 43.7956 2.36182 41.4995L3.29644 41.1439C2.78993 39.8128 2.36794 38.4212 2.02973 36.9881L1.05647 37.2178C0.515325 34.9248 0.184877 32.537 0.0588926 30.1299L1.05753 30.0776C1.01945 29.35 1.00049 28.6205 1.00049 27.8912C1.00049 27.1713 1.0226 26.455 1.06633 25.7437L0.068213 25.6823C0.215404 23.2884 0.600798 20.9487 1.20753 18.7143L2.17259 18.9763C2.55181 17.5797 3.01973 16.2273 3.57149 14.932L2.65148 14.5401C3.59468 12.3259 4.77697 10.2687 6.17793 8.43048L6.97328 9.03662C7.40506 8.47005 7.85795 7.92577 8.33119 7.4056C8.76715 6.92641 9.22103 6.48123 9.69146 6.06778L9.03131 5.31665C10.6856 3.8628 12.5368 2.77625 14.5304 1.97767L14.9023 2.90597C16.0819 2.43344 17.3201 2.06411 18.6065 1.78171L18.392 0.804966C20.446 0.354065 22.5989 0.121246 24.8029 0.0372678L24.841 1.03654C25.4963 1.01158 26.1573 1 26.8228 1C27.5022 1 28.1819 1.00584 28.8601 1.02057L28.8818 0.0208021C31.0994 0.0689652 33.3142 0.211286 35.4445 0.553696L35.2858 1.54102C36.6223 1.75584 37.913 2.05 39.14 2.44852L39.4489 1.49743C41.5602 2.18319 43.5167 3.17212 45.2207 4.59129L44.5807 5.3597C45.0659 5.76373 45.5289 6.20501 45.9676 6.68718C46.4545 7.22239 46.9298 7.79129 47.3904 8.39035L48.1831 7.78076C49.6181 9.64681 50.9068 11.7829 51.975 14.0846L51.0679 14.5056C51.69 15.846 52.2351 17.244 52.6877 18.6775L53.6413 18.3764C54.3806 20.7176 54.8805 23.1522 55.0776 25.5903L54.0808 25.6709C54.1408 26.4126 54.1716 27.1536 54.1716 27.8912Z"
          stroke={theme.primary}
          stroke-width="2"
          stroke-dasharray="5 8"
        />
      )}
      <path
        d="M47.4084 27.9223C47.4084 33.7342 44.4921 39.3701 41.0293 43.1792C37.5664 46.9883 32.4428 48 27.1593 48C21.8758 48 16.5656 47.1907 13.1054 43.3816C9.64526 39.5725 8.00049 33.7313 8.00049 27.9223C8.00049 22.1133 9.95982 16.6152 13.4226 12.809C16.8855 9.00286 21.8784 8 27.1593 8C32.4402 8 37.8997 8.4897 41.3625 12.2959C44.8253 16.102 47.4084 22.1104 47.4084 27.9223Z"
        fill={hover ? theme.secondary : theme.primary}
      />
      <path
        d="M34.3222 24.1155L19.4785 23.5972C19.3021 23.591 19.1794 23.7339 19.1743 23.8808L20.6103 38.3808C20.6041 38.5572 20.747 38.6799 20.894 38.685L31.8284 39.0669C32.0047 39.073 32.1274 38.9302 32.1326 38.7832L34.5765 24.4187C34.6404 24.2738 34.4986 24.1217 34.3222 24.1155Z"
        fill={hover ? theme.primary : theme.secondary}
      />
      <path
        d="M35.4172 19.7106L29.6561 19.5094C29.6571 19.48 29.6581 19.4506 29.6602 19.3918L29.6889 18.5688C29.7002 18.2455 29.4449 17.9717 29.1216 17.9604L25.124 17.8208C24.8007 17.8095 24.5269 18.0648 24.5156 18.3881L24.4869 19.2112C24.4859 19.2405 24.4838 19.2993 24.4828 19.3287L18.6923 19.1265C18.5453 19.1214 18.453 19.2359 18.4489 19.3535L18.3586 21.9401C18.3535 22.0871 18.4679 22.1793 18.5855 22.1834L35.3104 22.7675C35.4574 22.7726 35.5497 22.6581 35.5538 22.5406L35.6441 19.9539C35.6482 19.8364 35.5642 19.7157 35.4172 19.7106Z"
        fill={hover ? theme.primary : theme.secondary}
      />
    </svg>
  );
}

DeleteIcon.propTypes = {
  /** Determine if the icon is being hovered. */
  hover: bool,

  /** Sets the height/width of the icon. */
  dimension: number,

  /** Determine if the icon should be surrounded by a dashed border. */
  includeSurround: bool,
};

DeleteIcon.defaultProps = {
  hover: false,
  dimension: 45,
  includeSurround: true,
};

export default DeleteIcon;
